import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { UserIdService } from '../../../core/auth';
import { SearchAction } from '../../../core/features/store/actions/search.actions';
import { Pagination } from '../../../core/model';
import { AvailableSoldTosSearchParams, SoldTo } from '../../../core/model/user.model';
import { SoldToOnUserDetailsFacade } from '../facades';
import { SoldToActions } from '../store/actions';
import { SoldToSelectors } from '../store/selectors/index';
import { SOLD_TOS_ON_USER_DETAILS, StateWithSoldTo } from '../store/sold-to-state';

@Injectable()
export class SoldToOnUserDetailsService implements SoldToOnUserDetailsFacade {
  constructor(private store: Store<StateWithSoldTo>, private userIdService: UserIdService) {}

  searchForAvailableSoldTosOnUserDetails(searchParams: AvailableSoldTosSearchParams): void {
    this.userIdService.takeUserId(true).subscribe((userId) => {
      this.store.dispatch(new SoldToActions.LoadAvailableSoldTosOnUserDetails(searchParams, userId));
    });
  }

  getAvailableSoldTosOnUserDetails(): Observable<Array<SoldTo>> {
    return this.store
      .select(SoldToSelectors.getAvailableOnUserDetailsCombinedSearchPageResultsIdsSelector)
      .pipe(
        switchMap((results) => this.store.select(SoldToSelectors.getAvailableOnUserDetailsSearchResultEntries, { keys: results }))
      );
  }

  getAvailableSoldTosOnUserDetailsLoading(): Observable<boolean> {
    return this.store
      .select(SoldToSelectors.getAvailableOnUserDetailsSearchPageResultsSelector)
      .pipe(map((loaderState) => loaderState.loading));
  }

  getAvailableSoldTosOnUserDetailsPagination(): Observable<Pagination | undefined> {
    return this.store.select(SoldToSelectors.getAvailableOnUserDetailsSearchPaginationSelector);
  }

  getSearchParametersForAvailableSoldTosOnUserDetails(key: string = 'latest'): Observable<AvailableSoldTosSearchParams> {
    return this.store.select(SoldToSelectors.getAvailableOnUserDetailsSearchParamsSelector).pipe(
      map((params) => params as AvailableSoldTosSearchParams),
      tap((params: AvailableSoldTosSearchParams) => {
        if (!params || !params.key) {
          this.updateSearchParametersForAvailableOnUserDetailsSoldTos({
            key: key,
            page: 0,
            count: 10,
          });
        }
      }),
      filter((params) => params && !!params.key)
    );
  }

  updateSearchParametersForAvailableOnUserDetailsSoldTos(searchParams: AvailableSoldTosSearchParams) {
    this.store.dispatch(new SearchAction(searchParams, SOLD_TOS_ON_USER_DETAILS));
  }
}
